import React from "react";
import "../../styles/brand.css";
import Layout from "../../components/Layout";
import ImageBanner from "../../components/ImageBanner";
import ServicesHero from "./ServicesHero";
import ServiceAreas from "./ServiceAreas";
import ServicesWhyChoose from "./ServicesWhyChoose";
import ServicesFinalCta from "./ServicesFinalCta";
import { SERVICES_SEO, buildServicesJsonLd } from "./servicesSeo";

const Services = () => {
  return (
    <Layout
      title={SERVICES_SEO.title}
      description={SERVICES_SEO.description}
      keywords={SERVICES_SEO.keywords}
      canonical={SERVICES_SEO.canonical}
      ogImage={SERVICES_SEO.ogImage}
      jsonLd={buildServicesJsonLd()}
    >
      <main className="services-page brand-page w-full overflow-x-hidden bg-white">
        <ImageBanner
          src="/assets/banners/our-services.jpeg"
          alt="Our Services — MBA Solutions"
          width={1872}
          height={576}
          whole
        />
        <ServicesHero />
        <ServiceAreas />
        <ServicesWhyChoose />
        <ServicesFinalCta />
      </main>
    </Layout>
  );
};

export default Services;
